<template>
  <div v-if="noticeExists" id="notice">
    <div class="notice-inner container vertical-center column-sm">
      <img :src="renderImage(currentNotice.image)" alt="">
      <p>{{ currentNotice.text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notices',
  data () {
    return {
      content: {
        'confirm_email': {
          image: 'confirm-email.png',
          text: 'Check your email inbox for another 500MBs of free data... ' +
                'or there\'s a bigger TunnelBear ready for you below.'
        },
        'account_confirmed': {
          image: 'account-confirmed.png',
          text: 'Account verified! You can now use TunnelBear to enjoy 500MB ' +
          'of private browsing each month.'
        },
        'low_data': {
          image: 'low-on-data.gif',
          text: 'Grrrr! Looks like you\'re almost out of data for this month.'
        },
        'no_data': {
          image: 'out-of-data.gif',
          text: 'Grrrr! Your TunnelBear is out of free data for the month.  Upgrade to a bigger bear, with unlimited data below.'
        }
      }
    }
  },
  computed: {
    noticeExists: function () {
      return ['no_data', 'low_data', 'confirm_email', 'account_confirmed'].indexOf(this.$route.query.notice) > -1
    },
    currentNotice: function () {
      return this.noticeExists ? this.content[this.$route.query.notice] : {}
    }
  },
  methods: {
    renderImage: function (fileName) {
      const image = require('./images/' + fileName)
      return image
    }
  }
}
</script>

<style scoped lang="stylus" src="./notices.styl" >
